var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChart12(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 59.999,
    viewBox: "0 0 60 59.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_204",
    "data-name": "Group 204",
    transform: "translate(-641.234 -587)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_5",
    "data-name": "Union 5",
    d: "M1.471,20.729h0A30,30,0,0,1,30,0V15A15,15,0,0,0,15.735,25.365h0A15,15,0,0,0,21.8,42.56L13.6,55.121A30,30,0,0,1,1.471,20.729Z",
    transform: "translate(641.233 587)",
    fill: "#bf0a76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_4",
    "data-name": "Union 4",
    d: "M0,34.957,8.817,22.822a15,15,0,0,0,17.632,0h0a15,15,0,0,0,5.2-17.479L45.663,0a30,30,0,0,1-9.207,34.044h0A30,30,0,0,1,0,34.957Z",
    transform: "translate(653.6 606.314)",
    fill: "#df85bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M78.189,30.729A30,30,0,0,0,49.36,10l.15,15A15,15,0,0,1,63.925,35.365Z",
    transform: "translate(621.572 577)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart12);
export default __webpack_public_path__ + "static/media/chart12.b97a430bb1a5d7cc27941361faaedd69.svg";
export { ForwardRef as ReactComponent };